import { EditOutlined, EllipsisOutlined, FieldTimeOutlined, MenuOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { useNavigate } from 'react-router';

import { DropdownLabel } from '@/shared/components';
import { ROUTES } from '@/shared/consts';
import { ESchoolType } from '@/shared/types';

import styles from '../../Dropdown.module.scss';

type TProps = {
  id: number;
  openUnpublishModalCb: VoidFunction;
  schoolType: ESchoolType;
};

export const PublishedDropdown = ({ id, openUnpublishModalCb, schoolType }: TProps) => {
  const navigate = useNavigate();

  const dropdownItems: MenuProps['items'] = [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: (
        <DropdownLabel
          text="Просмотр"
          onClick={() => navigate(`${id}/${ROUTES.VIEW}`)}
        />
      ),
    },
    {
      key: 'unpublish',
      icon: <FieldTimeOutlined />,
      label: (
        <DropdownLabel
          text="Снять с публикации"
          onClick={openUnpublishModalCb}
        />
      ),
    },
  ];

  if (schoolType === ESchoolType.Public) {
    dropdownItems.push({
      key: 'selection-panel',
      icon: <MenuOutlined />,
      label: (
        <DropdownLabel
          text="Панель отбора"
          onClick={() => navigate(`${id}/${ROUTES.SELECTION_PANEL}`)}
        />
      ),
    });
  }

  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        items: dropdownItems,
        onClick: (dropdownItem) => {
          dropdownItem.domEvent.stopPropagation();
        },
      }}
      classNames={{
        root: styles['dropdown-overlay'],
      }}
    >
      <Button
        className={styles['dropdown-button']}
        onClick={(evt) => evt.stopPropagation()}
      >
        <EllipsisOutlined />
      </Button>
    </Dropdown>
  );
};
